import { render, staticRenderFns } from "./SettingsEmail.vue?vue&type=template&id=48a94e4b&scoped=true&"
import script from "./SettingsEmail.vue?vue&type=script&lang=js&"
export * from "./SettingsEmail.vue?vue&type=script&lang=js&"
import style0 from "./SettingsEmail.vue?vue&type=style&index=0&id=48a94e4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a94e4b",
  null
  
)

export default component.exports